import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkCardPlaceholder } from "uitk-react-cards";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

import SponsoredContentRenderer from "components/flexComponents/SponsoredContentRenderer/SponsoredContentRenderer";
import SponsoredContentMarquee from "components/flexComponents/MesoCollapsibleGroupRegion/SponsoredContentMarquee/SponsoredContentMarquee";

interface GridViewProps {
  title: string;
  innerTitle: string;
  UCIs: string[];
}

interface GridItemProps {
  centerStage?: boolean;
  uci: string;
}

interface TitleProps {
  title: string;
}

const headingConfig: UitkHeadingProps = { tag: "h2", size: 3 };
const Title: React.FC<TitleProps> = ({ title }) => (
  <UitkSpacing padding={{ blockend: "three" }}>
    <UitkHeading {...headingConfig}>{title}</UitkHeading>
  </UitkSpacing>
);

const MarqueeGridItem: React.FC<GridItemProps> = ({ centerStage, uci }) => {
  return (
    <UitkLayoutGridItem
      className={`meso-native-card-${centerStage ? "center-stage" : "small"}`}
      rowSpan={centerStage ? 2 : 1}
      colSpan={centerStage ? { large: 8, small: 12 } : { large: 4, small: 12 }}
    >
      <div>
        <Experiment name="MeSo_Marquee_Gallery_POC">
          <ExperimentControl>
            <meso-native
              uci={`${uci}CONTROL`}
              nativetype="marquee"
              isfluid
              adslot={`${uci}CONTROL`}
              data-testid="meso-native"
            />
            <UitkCardPlaceholder className="uitk-card uitk-card-roundcorner-all uitk-card-empty" />
          </ExperimentControl>
          <ExperimentVariant bucket={1}>
            <SponsoredContentMarquee sponsoredContentId={`${uci}TEST1`} />
            <UitkCardPlaceholder className="uitk-card uitk-card-roundcorner-all uitk-card-empty" />
          </ExperimentVariant>
          <ExperimentVariant bucket={2}>
            <SponsoredContentMarquee sponsoredContentId={`${uci}TEST2`} />
            <UitkCardPlaceholder className="uitk-card uitk-card-roundcorner-all uitk-card-empty" />
          </ExperimentVariant>
          <ExperimentVariant bucket={3}>
            <meso-native uci={uci} nativetype="marquee" isfluid adslot={uci} data-testid="meso-native" />
            <UitkCardPlaceholder className="uitk-card uitk-card-roundcorner-all uitk-card-empty" />
          </ExperimentVariant>
        </Experiment>
      </div>
    </UitkLayoutGridItem>
  );
};

export const MarqueeGridView: React.FC<GridViewProps> = ({ title, innerTitle, UCIs }) => {
  return (
    <>
      <SponsoredContentRenderer />
      {title && <Title title={title} />}
      {innerTitle && <Title title={innerTitle} />}
      <UitkLayoutGrid columns={12} rows={2} space="three">
        <MarqueeGridItem uci={UCIs[0]} centerStage />
        <MarqueeGridItem uci={UCIs[1]} />
        <MarqueeGridItem uci={UCIs[2]} />
      </UitkLayoutGrid>
    </>
  );
};
